<div class="footer__{{ footerLocation }}-container {{ alignClass }} {{ flexDirection }} flex">
  @for (link of links; track link; let first = $first; let last = $last) {
    <a
      class="{{ footerLocation === 'bottom' ? 'pb-0' : 'pb-3' }} text-sm leading-6 flex {{ linkClass }}"
      [href]="link.linkUrl"
      [attr.target]="link.newTab ? '_blank' : null"
      [attr.nofollow]="link.nofollow"
      [attr.aria-label]="link.newTab ? (link.linkText + (link.newTab ? ' (opens in a new tab)' : '')) : null"
      [attr.aria-labelledby]="!link.newTab ? accessibilityService.getAriaLabelledby(link.linkText) + '-nav-label' : null"
      >
      @if (link.icon) {
        <fa-icon
          class="mr-2 h-4 w-4 self-center -mt-1 justify-self-end fa-1x"
          [icon]="[iconPrefix, link.icon]"
        ></fa-icon>
      }
      <span class="md:inline">{{ link.linkText }}</span>
      @if (footerLocation === 'bottom' && !last) {
        <span class="mx-[10px] divider">|</span>
      }
      <!-- Hidden Context -->
      @if (!link.newTab) {
        <span [attr.id]="accessibilityService.getAriaLabelledby(link.linkText) + '-nav-label'" class="sr-only">{{accessibilityService.getCompleteTextContextForButton(link.linkUrl, link.linkText)}}</span>
      }
    </a>
  }
</div>